export default __webpack_public_path__ + "static/media/14-Bothayna-Emad-Hawsawi.0805b5ee.png";